export const normalizeEmail = (email) => {
    return email.trim().toLowerCase();
};
//# sourceMappingURL=email.js.map